import { useState, useEffect } from 'react';

export const condClass = (classes: Record<string, boolean>): string => {
  return Object.entries(classes)
    .filter((item: [string, boolean]) => item[1])
    .map((item: [string, boolean]) => item[0])
    .join(' ');
};

export const serialArray = (size: number, fromZero?: boolean): number[] => {
  if (fromZero) {
    return Array.from(Array(size).keys());
  }

  return Array.from(Array(size + 1).keys()).splice(1);
};

export const indexesArray = (size?: number): number[] => {
  return serialArray(size || 0, true);
};

export default function useDebounce<Params>(values: Params, delay: number): Params {
  const [debouncedValue, setDebouncedValue] = useState<Params>(values);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(values);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [values]);

  return debouncedValue;
}
